import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { EmployeeInfoService } from '@core/services/employee-info.service';
import { EmployeeInfo } from '@typeDefs/home/responses/home';

export const employeeInfoResolver: ResolveFn<any> = () => {
  const employeeInfoService = inject(EmployeeInfoService);
  const http = inject(HttpClient);

  if (employeeInfoService.getEmployeeInfo() == null) {
    return http
      .get<EmployeeInfo>('/Employee/GetInfo')
      .toPromise()
      .then(response => {
        employeeInfoService.setEmployeeInfo(response);
      });
  }
};
